module.exports = __webpack_public_path__ + "static/media/tinder_logo.0883c4b1.jpg";